import { ClassName } from '../enums/Checkout';

export function toSelector(className: ClassName): string {
  return `.${className}`;
}
